import { z } from 'zod';

export const formSchema = z.object({
  email: z.string(),
  volunteerId: z.string().min(1, { message: 'Volontär ID måste anges.' }),
  password: z.string().min(1, { message: 'Lösenord måste anges.' }),
  location: z.string().min(1, { message: 'Plats måste anges.' }),
});
